import { Box, Typography } from '@mui/material';
import { Modal } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';

import Carousel from '@/components/UI/Carousel';
import MainButton from '@/components/UI/mobile/MainButton';
import type Announcement from '@/types/database/announcement';

import Label from '../Label';
import { DownloadFile } from '../styles';
import { announcementTypes } from '../utils';
import AnnouncementSection from './AnnouncementSection';

interface CategoryType {
  id: string;
  name: string;
  color: string;
}

const previewModalBodyStyle = {
  padding: 0,
  maxHeight: '95dvh',
};

const AnnouncementDetail: React.FC<{
  item: Announcement;
  showDownloadBtn: boolean;
  onClose: () => void;
  categories: CategoryType[];
}> = ({ item, onClose, showDownloadBtn, categories }) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<boolean>(false);

  const titleName = item.fileType === 'file' ? '檔案' : '圖片';
  const showPreviewImagePath =
    item.fileType === 'file'
      ? item.files.map((file) => file.response.png).flat()
      : item.files.map((file) => file.response.showPath);
  const selectedAnnouncement = categories.find(
    (category) => category.name === item.type
  );

  return (
    <Box
      id="announcement-detail"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > *:not(:last-of-type)': {
          marginBottom: '0.9rem',
        },
      }}
    >
      <Box
        id="announcement-detail-content"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowY: 'auto',
          '& > *:not(:last-of-type)': {
            marginBottom: '0.9rem',
          },
        }}
      >
        <Box
          id="announcement-detail-labels"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              '& > *:not(:last-of-type)': {
                mr: '0.5rem',
              },
            }}
          >
            <Label type={selectedAnnouncement} />
            {item.checkedStatus && (
              <Label
                type={announcementTypes.find((type) => type.name === '置頂')}
              />
            )}
          </Box>
          <Typography
            variant="body1"
            sx={{
              justifySelf: 'flex-end',
            }}
          >
            {moment(item.announcementTime).format('YYYY-MM-DD')}
          </Typography>
        </Box>
        <AnnouncementSection title="標題">
          <Typography
            sx={{
              fontSize: '1.9rem',
            }}
          >
            {item.title}
          </Typography>
        </AnnouncementSection>
        <AnnouncementSection title="內容">
          <Typography variant="h1">{item.content}</Typography>
        </AnnouncementSection>
        {item.files[0]?.response && (
          <AnnouncementSection title={titleName}>
            <Box
              sx={{
                width: '100%',
                overflow: 'hidden',
                border: '1px solid #707070',
                borderRadius: '0.4rem',
                '& > img': {
                  width: '100%',
                  maxHeight: '100%',
                },
                '@media (orientation: landscape)': {
                  width: '50%',
                },
              }}
            >
              {showPreviewImagePath.map((item, index) => (
                <img
                  key={index}
                  src={item}
                  alt="圖片"
                  onClick={() => setIsPreviewModalOpen(true)}
                />
              ))}
              {/* <img
                src={showImagePath}
                alt="圖片"
                onClick={() => setIsPreviewModalOpen(true)}
              /> */}
              <Modal
                open={isPreviewModalOpen}
                footer={null}
                centered
                bodyStyle={previewModalBodyStyle}
                width="auto"
                onCancel={() => setIsPreviewModalOpen(false)}
              >
                <Carousel images={showPreviewImagePath} />
              </Modal>
            </Box>
            {item.fileType === 'file' && showDownloadBtn && (
              <>
                {item.files.map((item, index) => (
                  <DownloadFile
                    key={index}
                    style={{ marginLeft: 10 }}
                    download={item.response.oldName}
                    href={item.response.showPath}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {`${item.response.oldName}下載`}
                  </DownloadFile>
                ))}
              </>
              // <DownloadFile
              //   download={item.files[0].response.oldName}
              //   href={item.files[0].response.showPath}
              //   target="_blank"
              //   rel="noreferrer"
              // >
              //   {`${item.files[0].response.oldName}下載`}
              // </DownloadFile>
            )}
          </AnnouncementSection>
        )}
      </Box>
      <MainButton onClick={onClose}>返回</MainButton>
    </Box>
  );
};

export default AnnouncementDetail;
